import { createSlice } from "@reduxjs/toolkit";
import { fetchPreSignaturePdf, fetchSignedPdf } from "./signatureThunks";

const initialState = {
  url: null,
  isLoading: false,
  error: null,
  pdfName: null,
  modalConsent: false,
};

const signatureSlice = createSlice({
  name: "signature",
  initialState,
  reducers: {
    clearSignature: (state) => {
      if (state.url) URL.revokeObjectURL(state.url);
      return initialState;
    },
    setModalConsent: {
      reducer(state, action) {
        state.modalConsent = action.payload;
      },
    },
  },
  extraReducers: (builder) => {
    const pending = (state) => {
      state.isLoading = true;
      state.error = null;
    };

    const rejected = (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Unexpected error";
    };

    const fulfilled = (state, action) => {
      state.isLoading = false;
      state.url = action.payload;
    };

    builder
      .addCase(fetchPreSignaturePdf.pending, pending)
      .addCase(fetchPreSignaturePdf.fulfilled, (state, action) => {
        state.pdfName = "unsigned";
        fulfilled(state, action);
      })
      .addCase(fetchPreSignaturePdf.rejected, rejected)
      .addCase(fetchSignedPdf.pending, pending)
      .addCase(fetchSignedPdf.fulfilled, (state, action) => {
        state.pdfName = "signed";
        fulfilled(state, action);
      })
      .addCase(fetchSignedPdf.rejected, rejected);
  },
});

export const { clearSignature, setModalConsent } = signatureSlice.actions;
export default signatureSlice.reducer;
